import React from 'react';
import { loadable } from '@shared/core/loadableFromNamedExport';
import { Skeleton } from '../Skeleton';

export const LazyJoyInteractableMap = loadable(
  () =>
    import(
      /* webpackChunkName: "content/shared/joy-interactable-map" */
      './JoyInteractableMap'
    ),
  'JoyInteractableMap',
  {
    fallback: (
      <Skeleton
        isReady={false}
        width="100%"
        height="100%"
      />
    ),
  },
);
